/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSimilarItemsGridSeller_item$ref = any;
export type PdpRespSimilarItemsGridSeller_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": PdpRespSimilarItemsGridSeller_item$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = '3e6feaa7c5b230a4cf8e00fda209f4b9';
export default node;
